import { validatePrimitiveSyncFull } from 'utils/validation';
import type { PrimitiveValidationResult } from 'utils/validation/validate-schema/validate-schema.types';
import { z } from 'zod';

const creativeNameSchema = z.string().min(1, 'Required');

export const validateCreativeName = (creativeName: string): PrimitiveValidationResult =>
  validatePrimitiveSyncFull({
    schema: creativeNameSchema,
    value: creativeName,
  });
